import moment from "moment";
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import { Alert } from "rsuite";
import login2 from '../../assets/images/login1.jpg';
import constants from "../../constants";
import services from "../../services";
import { Input } from "../common";
import { Login } from "./index";

const hostname = window.location.hostname
const recaptchaRef = React.createRef();
const formFeilds = [
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    class: "two-element first-name",
    invalidMsg: null
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    class: "two-element last-name",
    invalidMsg: null
  },
  {
    name: "email",
    label: "Email Address",
    type: "email",
    class: "single-element",
    invalidMsg: null,
    emailCheckRequired: true
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    class: "single-element",
    invalidMsg:
      "Use 8-30 characters with a mix of upper & lower case letters, numbers & symbols"
  }
];

const api = services.api;

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    var emailId = null;
    if (props.parent.location.state && props.parent.location.state.from.search) {
      const urlParams = new URLSearchParams(props.parent.location.state.from.search);
      emailId = urlParams.get('lead_email');
    }
    this.state = {
      formData: {
        firstName: null,
        lastName: null,
        email: emailId,
        password: null,
        tncAgreed: null
      },
      valid: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        valid: null
      },
      tncContent: null,
      tncToolTipVisible: false,
      visible: false, //open terms and conditions model
      showPassword: false,
      recaptchaValidation: null,
      recpatchaValue: null,
      disableButton : false
    };
    this.onSubmit = this.onSubmit.bind(this);

    api.get(constants.signUpTnC).then(res => {
      this.setState({
        tncContent: res.data[0].html_display_message
      });
    });

  }


  componentDidMount() {
    if (window.localStorage.getItem("user_token")) {
      this.props.parent.history.push("/");
    }

    let url = new URL(window.location.href);
    let source = url.searchParams.get('source');
    window.localStorage.setItem('source', source);
    // this.setOrigin();
    //handled redirection shopify app store handle
    if (this.props.parent.location.state && this.props.parent.location.state.from.search) {
      window.localStorage.setItem("search", this.props.parent.location.state.from.search);
    }
  }

  showTncPopUp(value) {
    if (this.state.formData["tncAgreed"] === null || this.state.formData["tncAgreed"] === "") {
      if (value) {
        this.setState({ tncToolTipVisible: true })
      } else {
        this.setState({ tncToolTipVisible: false })
      }
    }
  }

  setOrigin = () => {
    console.log("==========");
    console.log(document.referrer);
    console.log("==========");

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    window.localStorage.setItem('origin', "factoreal");
    window.localStorage.setItem('contact', urlParams.get('contact'));
    window.localStorage.setItem('amount', urlParams.get('amount'));

  };

  showModal = () => {
    this.setState({ visible: true });
  };

  handleOk = e => {
    this.setState({ visible: false });
  };

  handleCancel = e => {
    this.setState({ visible: false });
  };

  render() {
    const bodyStyle = {
      maxHeight: "500px",
      overflow: "auto"
    };
    return (
      <section className="login signup">
        <input type="hidden" id="Source" value="NA" />
        <React.Fragment>
          <div className="col-md-6 col-sm-6 col-xs-12 login-left-container">
            <Login image={login2} header="Get started to boost your growth." loginType="signup" />
          </div>
          <div className="col-md-6 col-sm-6 col-xs-12 login-right-container">
            <div className="login-inner-container">
              <h4>Create your account</h4>
              <p className="account">
                Already have a Marketing Engine account?<Link to="/signin"><span>Login here</span></Link>
              </p>
              {/* <h5>No credit card required. Instant setup.</h5> */}
              <form onSubmit={e => { e.preventDefault(); }}>
                <div className="row pl-3 pr-3">
                  {formFeilds.map((item, index) => (
                    <Input
                      containerClass={
                        (index < 2
                          ? (index == 1 ? "col-md-6 col-sm-6 col-xs-12 pl-0 pr-0 safari_signup-field" : "col-md-6 col-sm-6 col-xs-12 pl-0")
                          : "col-md-12 col-sm-12 col-xs-12 pl-0 pr-0")
                      }
                      type={item.type}
                      name={item.name}
                      placeholder={item.label}
                      value={this.state.formData[item.name]}
                      onChange={this.inputEntered}
                      key={index}
                      id={"custom-css-outlined-input_" + index}
                      getValid={this.captureValidFlag}
                      checkEmailDuplicates={item.emailCheckRequired}
                      customErrMsg={item.invalidMsg}
                      showPassword={this.state.showPassword}
                      handleClickShowPassword={() => { this.showPasswordHandler(); }}
                    />
                  ))}
                </div>
                <div className="clearfix"></div>
                {/* <Button variant="secondary">Sec</Button> */}
                <div className="signup-captch-container">
                  {
                    constants.captcha_whitelist.includes(hostname) ?
                      <ReCAPTCHA
                        sitekey={constants.recaptchaSitekey}
                        onChange={this.onChangeRecaptcha}
                        onExpired={this.onExpiredRecaptcha}
                        onErrored={this.onErrorRecaptcha}
                        size="normal"
                        ref={recaptchaRef}
                      />
                      : null
                  }
                </div>
                <div className="tncSelection">
                  {this.state.tncToolTipVisible ? (
                    <div className="tooltipHeader">
                      <div className="tooltiptext">Please agree to terms and Conditions</div>
                    </div>) : <div className="tooltipHeader"></div>}

                  <Input
                    type="checkbox"
                    novalidate="true"
                    name="tncAgreed"
                    value={this.state.formData["tncAgreed"]}
                    onChange={this.inputEntered}
                  >
                    <span className="click-btn">{`I agree to Factoreal’s `}</span>
                    <a href="https://satisfilabs.com/terms-and-conditions/" target="_blank" className="term-condition">Terms of Use </a>
                    <span style={{ marginLeft: 5 }} className="click-btn"> and </span>
                    <a href="https://www.comviva.com/policy.htm" target="_blank" className="term-condition">Privacy Policy.</a>
                  </Input>

                </div>
                <a
                  className="btn btn-primary-cta"
                  onClick={this.state.disableButton === false ? this.onSubmit : null}
                  disabled={constants.captcha_whitelist.includes(hostname) ?
                    !(this.state.formData.tncAgreed && this.state.valid.valid) || !this.state.recaptchaValidation :
                    !(this.state.formData.tncAgreed && this.state.valid.valid)
                  }
                >
                  Start Free Trial
                  </a>
              </form>
              {/*<p className="or">
                <span>OR</span>
              </p>
              <span
                onMouseEnter={() => this.showTncPopUp(true)}
                onMouseLeave={() => this.showTncPopUp(false)}>
                <SocialMediaLogin location={this.props.parent.location.pathname} tncChecked={this.state.formData["tncAgreed"]}
                  google="Connect with Google" facebook="Connect with Facebook" />
                </span>*/}
            </div>
          </div>

        </React.Fragment>
      </section>
    );
  }

  inputEntered = (feildName, value) => {
    let values = {
      ...this.state.formData
    };
    values[feildName] = value ? value : "";
    this.setState({
      formData: {
        ...values
      }
    });
  };

  captureValidFlag = (feildName, value) => {
    let values = {
      ...this.state.valid
    };
    values[feildName] = value;
    this.setState({
      valid: {
        ...values,
        valid:
          values["firstName"] &&
          values["lastName"] &&
          values["email"] &&
          values["password"]
      }
    });
  };

  onSubmit = async e => {
    this.setState({disableButton: true});
    const queryString = window.location.search;
    let origin = window.localStorage.getItem("origin")
    e.preventDefault();
    if (!(constants.captcha_whitelist.includes(hostname) ?
      !(this.state.formData.tncAgreed && this.state.valid.valid) || !this.state.recaptchaValidation :
      !(this.state.formData.tncAgreed && this.state.valid.valid))) {
      // var today = new Date();
      // var date =
      //   today.getFullYear() +
      //   "-" +
      //   (today.getMonth() + 1) +
      //   "-" +
      //   today.getDate();
      // var time =
      //   today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      // var dateTime = date + " " + time;
      // let dateTime=moment.unix()
      let data = {
        stage: 0,
        firstname: this.state.formData.firstName,
        lastname: this.state.formData.lastName,
        email: this.state.formData.email,
        password: this.state.formData.password,
        tnc_checked: this.state.formData.tncAgreed,
        registered_date: moment().valueOf(),
        recpatchaValue: this.state.recpatchaValue,
        source: window.localStorage.getItem('source')
      };
      if (origin === "factoreal") {
        data.origin = window.localStorage.getItem("origin")
      }
      // call the  signup api
      try {
        const response = await api.post(constants.userSignup, data);
        console.log("response", response);
        if (origin === "factoreal") {
          window.localStorage.setItem("id", response.data.user.id);
          window.localStorage.setItem("user_token", response.data.jwt);
          window.localStorage.setItem("username", response.data.user.username);
          window.localStorage.setItem("firstname", response.data.user.firstname || response.data.user.username);
          window.localStorage.setItem("email", response.data.user.email);
          response.data.user.enterprise
            ? window.localStorage.setItem("enterprise_id", response.data.user.enterprise.id) : null;
          if (response.data.user.enterprise) {
            window.localStorage.setItem("org_name", response.data.user.enterprise.org_name);
          } else {
            window.localStorage.setItem("org_name", "Enterprise Name");
          }
          this.props.parent.history.push(`/onboard1/${queryString}`);
        } else {
          this.props.parent.history.push("/signin");
          Alert.success(
            `We have sent a verification link to your email. Plaese verify your account.`,
            10000
          );
          this.setState({disableButton: false});
        }
      }
      catch (error) {
        if (constants.captcha_whitelist.includes(hostname)) {
          recaptchaRef.current.reset();
        }

        this.setState({
          recaptchaValidation: false,
          disableButton: false
        })

        Alert.error(error.response.data.message[0].messages[0].message || 'Something went wrong');
      }
    }
  };

  onChangeRecaptcha = (value) => {
    this.setState({
      recaptchaValidation: true,
      recpatchaValue: value
    })
  }

  onExpiredRecaptcha = () => {
    this.setState({
      recaptchaValidation: false
    })
  }

  onErrorRecaptcha = () => {
    this.setState({
      recaptchaValidation: false
    })
  }

  setCaretPosition = (ctrl, pos) => {
    // Modern browsers
    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos);

      // IE8 and below
    } else if (ctrl.createTextRange) {
      var range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd('character', pos);
      range.moveStart('character', pos);
      range.select();
    }
  }

  showPasswordHandler = () => {
    this.setState({ showPassword: !this.state.showPassword }, () => {
      (() => {
        let input = document.getElementById('custom-css-outlined-input_3');
        this.setCaretPosition(input, input.value.length);
      })()
    });
  }


}
export default SignUp;
